// @ts-nocheck

import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import { type BetTemplate } from '../../types/bet';
import { type BetGroupOutcome, type PresentationItem } from '../../types/betGroup';
import { formatSpecifier, getStartPosition } from '../../utils/sliderUtils';
import Slider from '../Slider';

const StyledSlider = styled(Slider)`
  width: 100%;
  font-size: 90%;
`;

const SliderLineWrapper = styled.div`
  display: flex;
  align-items: center;
`;

type SliderLinePropsType = {
  outcomes: BetGroupOutcome[];
  matchIsAvailable?: boolean;
  betTemplate: BetTemplate;
  betPresentationMode: PresentationItem;
  BetGroupComponent: unknown;
  hideTooltip?: boolean;
};

const SliderLine = ({
  outcomes,
  betTemplate,
  betPresentationMode,
  BetGroupComponent,
  hideTooltip,
}: SliderLinePropsType) => {
  const [betIndex, setBetIndex] = useState(getStartPosition(outcomes.length, betPresentationMode.defaultPosition));
  const [outcome, setOutcome] = useState(outcomes[betIndex]);

  const onValueChange = useCallback((v) => {
    setBetIndex(v);
  }, []);

  useEffect(() => {
    setOutcome(outcomes[betIndex]);
  }, [outcomes, betIndex]);

  const formatLabel = useCallback(
    (idx) => formatSpecifier(outcomes?.[idx].specialBetValue, betPresentationMode.labelSpecifier),
    [betPresentationMode.labelSpecifier, outcomes],
  );
  const disabled = outcomes.length === 1;

  return (
    <SliderLineWrapper>
      <StyledSlider
        step={1}
        min={0}
        max={disabled ? 2 : outcomes.length - 1}
        value={betIndex}
        onChange={onValueChange}
        formatTooltipLabel={!hideTooltip && betPresentationMode?.labelSpecifier ? formatLabel : null}
        hideAnchors
        hideTooltip={hideTooltip || !betPresentationMode?.labelSpecifier}
        disabled={disabled}
      />
      <BetGroupComponent
        matchId={outcome.matchId}
        betId={outcome.betId}
        oddId={outcome.id}
        betTemplate={betTemplate}
        showPercentDistribution={false}
      />
    </SliderLineWrapper>
  );
};

export default SliderLine;
